import * as action_types from "../actions/action_types";

const initialState = {
  token: null,
  error: null,
  loading: false,
  user: null,
  forget_email: null, // the email the enter for forget password
  login_email: "", //the email the user try to login with or/and to register with
  reset_success: false,
  current_password: '',
  new_password: '',
  // vertification_sent: false,
  message: null,
  otp: null
};

const authLogout = (state, action) => {
  return {
    ...state,
    token: null,
    user: null,
  
  };
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case action_types.AUTH_START:
      return {
        ...state,
        error: null,
        loading: true,
        login_email: action.email,
      };
    case action_types.AUTH_SUCCESS:
      return {
        ...state,
        token: action.authData.token,
        error: null,
        loading: false,
        user: action.user,
        message: action.message
      };
    case action_types.AUTH_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case action_types.AUTH_LOGOUT:
      return authLogout(state, action);
    case action_types.REGISTER_START:
      return {
        ...state,
        loading: true,
        error: null,
        // vertification_sent: false,
      };
    case action_types.REGISTER_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        login_email: action.email,
        token: action.registerData.token || null,
        user: action.user,
        message: action.message
      };
    case action_types.REGISTER_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    // case action_types.FACEBOOK_AUTH_FAILED:
    //   return {
    //     ...state,
    //     loading: false,
    //     error: action.error,
    //   };
    // case action_types.GOOGLE_AUTH_FAILED:
    //   return {
    //     ...state,
    //     loading: false,
    //     error: action.error,
    //   };
    case action_types.START_FORGET_PASSWORD:
      return {
        ...state,
        error: null,
      };
    case action_types.FORGET_PASSWORD_EMAIL_SENT:
      return {
        ...state,
        forget_email: action.email,
        error: null,
      };
    case action_types.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        reset_success: true,
        error: null,
        forget_email: null,
        message: action.message
      };
    case action_types.FORGET_PASSWORD_FAILED:
      return {
        ...state,
        error: action.error,
      };
    case action_types.RESET_PASSWORD_FAILED:
      return {
        ...state,
        reset_succes: false,
        error: action.error,
      };
    case action_types.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        error: null,
        // current_password: action.currentPassword,
        // new_password: action.newPassword,
        message: action.message
      };
    case action_types.CHANGE_PASSWORD_FAILED:
      return {
        ...state,
        error: action.error,
      };
    case action_types.CLEAR_AUTH_ERROR:
      return {
        ...state,
        error: null,
      };
    case action_types.CLEAR_AUTH_MESSAGE:
      return {
        ...state,
        message: null,
      };
    // case action_types.VERTIFICATION_SEND_START:
    //   return {
    //     ...state,
    //     loading: true,
    //   };
    // case action_types.VERTIFICATION_SENT:
    //   return {
    //     ...state,
    //     loading: false,
    //   };
    default:
      return state;
  }
};
export default reducer;
